import { memo, useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from '@tabeeb/store'
import { getContentSharingDialogState } from '@tabeeb/modules/contentSharings/selectors'
import { closeContentSharingDialog, resetState } from '@tabeeb/modules/contentSharings/actions'
import { Dialog } from '@collaborate-health/uikit'
import Title from './Title'
import Content from './Content'
import Actions from './Actions'

const ContentSharingDialog = () => {
  const dispatch = useDispatch()
  const { stages, isOpen } = useSelector(getContentSharingDialogState)
  const [currentStageIndex, setCurrentStageIndex] = useState(0)

  useEffect(() => {
    return () => {
      dispatch(resetState())
    }
  }, [dispatch])

  const _handleCloseDialog = useCallback(() => {
    dispatch(closeContentSharingDialog())
  }, [dispatch])

  const props = { stages, currentStageIndex, setCurrentStageIndex, onClose: _handleCloseDialog }

  if (!isOpen) {
    return null
  }

  return (
    <Dialog open={isOpen} fullWidth maxWidth='sm'>
      <Title {...props} />
      <Content {...props} />
      <Actions {...props} />
    </Dialog>
  )
}

export default memo(ContentSharingDialog)

